import { Link } from 'react-router-dom';
import {
  FaLaptopCode,
  FaRobot,
  FaChalkboardTeacher,
  FaVideo,
  FaLightbulb,
} from 'react-icons/fa';
import './index.css';

const services = [
  {
    Icon: FaLaptopCode,
    title: 'Full-Stack Web Development',
    description:
      'Responsive React apps, REST APIs, and end-to-end web solutions — from idea to deployment.',
    tags: ['React', 'Node.js', 'JavaScript', 'REST APIs'],
  },
  {
    Icon: FaRobot,
    title: 'LLM Apps, RAG & AI Agents',
    description:
      'Intelligent applications powered by large language models, retrieval-augmented generation, and agent workflows.',
    tags: ['LLMs', 'RAG', 'AI Agents', 'Python'],
  },
  {
    Icon: FaChalkboardTeacher,
    title: 'Python Tutoring & CS Coaching',
    description:
      'Clear, structured teaching for Python fundamentals, problem-solving, and computer science concepts.',
    tags: ['Python', 'DSA', '1-on-1', 'Beginners'],
  },
  {
    Icon: FaVideo,
    title: 'Technical Content Creation',
    description:
      'Educational content that simplifies complex topics — proven reach with 6,000+ engaged followers.',
    tags: ['Instagram', 'Python', 'Education', 'Reels'],
  },
  {
    Icon: FaLightbulb,
    title: 'CS Problem Solving & SME Work',
    description:
      'Expert-level solutions for computer science assignments, debugging, and academic support.',
    tags: ['Chegg SME', 'Debugging', 'Algorithms', 'OOP'],
  },
];

const Services = () => (
  <section className="services">
    <h2 className="section-heading">Services I Offer</h2>
    <p className="section-subheading">
      Hire me for freelance projects, contract work, tutoring, or long-term roles. I deliver quality on deadline.
    </p>
    <div className="services-grid">
      {services.map(({ Icon, title, description, tags }) => (
        <article key={title} className="service-card glass-card">
          <div className="service-icon-wrap">
            <Icon className="service-icon" />
          </div>
          <h3 className="service-title">{title}</h3>
          <p className="service-description">{description}</p>
          <div className="service-tags">
            {tags.map((tag) => (
              <span key={tag} className="service-tag">{tag}</span>
            ))}
          </div>
        </article>
      ))}
    </div>
    <div className="services-cta">
      <p className="services-cta-text">Have a project in mind? Let&apos;s discuss scope, timeline, and budget.</p>
      <Link to="/contactme" className="btn-primary">Start a Conversation</Link>
    </div>
  </section>
);

export default Services;
